document.querySelectorAll('[data-knowledge]').forEach(root => {
  const input = root.querySelector('[data-knowledge-search]');
  const cards = Array.from(root.querySelectorAll('[data-knowledge-card]'));
  const list = root.querySelector('[data-knowledge-list]');
  const panels = Array.from(root.querySelectorAll('[data-knowledge-article]'));
  const baseTitle = document.title;
  const normalize = value => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ł/g, 'l');
  const filter = () => {
    const term = normalize(input.value.trim());
    let total = 0;
    cards.forEach(card => { const visible = normalize(card.dataset.keywords).includes(term); card.hidden = !visible; if (visible) total++; });
    root.querySelector('[data-knowledge-count]').textContent = `${total} ${total === 1 ? 'artykuł' : total > 1 && total < 5 ? 'artykuły' : 'artykułów'}`;
    root.querySelector('[data-knowledge-empty]').hidden = total !== 0;
    const pagination = root.querySelector('.ek__pagination');
    if (pagination) pagination.hidden = term.length > 0;
  };
  const showArticle = (handle, focus = false) => {
    const selected = panels.find(panel => panel.dataset.knowledgeArticle === handle);
    if (list) list.hidden = !!selected;
    panels.forEach(panel => panel.hidden = panel !== selected);
    document.title = selected ? `${selected.dataset.articleTitle} | EuropeLab` : baseTitle;
    if (selected) {
      const img = selected.querySelector('img');
      if (img) img.loading = 'eager';
      if (focus) selected.querySelector('h1').focus({ preventScroll: true });
    } else if (focus) root.querySelector('.ek__hero h1')?.focus({ preventScroll: true });
  };
  root.addEventListener('click', event => {
    const link = event.target.closest('[data-knowledge-open], [data-knowledge-back]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const handle = link.dataset.knowledgeOpen || '';
    if (handle && !panels.some(panel => panel.dataset.knowledgeArticle === handle)) return;
    event.preventDefault();
    const url = new URL(location.href);
    url.hash = '';
    if (handle) url.searchParams.set('peptyd', handle); else url.searchParams.delete('peptyd');
    history.pushState({}, '', url);
    showArticle(handle, true);
    window.scrollTo({ top: 0, behavior: 'instant' });
  });
  window.addEventListener('popstate', () => showArticle(new URL(location.href).searchParams.get('peptyd')));
  input.addEventListener('input', filter);
  root.querySelectorAll('[data-knowledge-term]').forEach(button => button.addEventListener('click', () => { input.value = button.dataset.knowledgeTerm; filter(); input.focus(); }));
  filter();
  showArticle(new URL(location.href).searchParams.get('peptyd'));
});
